export default __webpack_public_path__ + "static/media/three.25922f82.jpg";